import { get } from "./../api";

type Response = {
	data: {
		id: string;
		heading: string;
		slides: Array<any>;
	};
};

export function getRecommendation(param: string | number) {
	return get<Response>(
		"/actions/quantity-shop/product/get-recommendation?param=" + param
	);
}
